import React from "react";
import "./MinimalContactCard.css";
import * as FeatherIcon from "react-feather";

function getInitials(fullName = "") {
  return fullName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase() || "")
    .join("");
}

export default function MinimalContactCard({
  content,
  onClick = () => {},
}) {
  const isLoading =
    content?.templates?.every(
      (i) =>
        i?.subject === "Generating..." || i?.bodycontent === "Generating..."
    ) || false;

  return (
    <div
      className={`mc-contact-card`}
      onClick={!isLoading ? onClick : undefined}
      role="button"
      tabIndex={0}
      id={content?._id + "tab"}
    >
      <div className="mc-info">
        <div className="mc-top-row">
          {/* Left icon: spinner or tick */}
          <div className="mc-status-icon">
            {isLoading ? (
              <div className="mc-spinner"></div>
            ) : (
              <FeatherIcon.CheckCircle
                className="mc-check"
                size={16}
              />
            )}
          </div>

          {/* Name with shimmer overlay when loading */}
          <div className="mc-name-wrapper">
            <div className="mc-name" title={content?.name}>
              {content?.name}
            </div>
            {isLoading && <div className="mc-liquid-glass"></div>}
          </div>
        </div>
      </div>
    </div>
  );
}
